import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export const FinalCTA = () => {
  const openTypeform = () => {
    window.location.href = 'https://form.typeform.com/to/w7LMrDGe';
  };
  return <div className="w-full py-16 sm:py-24" data-id="element-72">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-73">
        <motion.div className="relative inline-block" whileHover={{
        scale: 1.02
      }} data-id="element-74">
          {/* Animated border glow */}
          <motion.div className="absolute inset-0 rounded-lg" style={{
          background: 'linear-gradient(90deg, #742EFF, #AE00FF, #742EFF)',
          backgroundSize: '200% 100%',
          padding: '2px',
          borderRadius: '0.5rem'
        }} animate={{
          backgroundPosition: ['0% 0%', '200% 0%']
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'linear'
        }} data-id="element-75">
            <div className="absolute inset-[2px] bg-[#020311] rounded-lg" data-id="element-76" />
          </motion.div>

          {/* Button */}
          <motion.button onClick={openTypeform} whileTap={{
          scale: 0.98
        }} className="relative z-10 inline-flex items-center gap-3 py-5 px-10 text-[#F5F5F7] font-bold rounded-lg text-xl sm:text-2xl bg-gradient-to-r from-[#742EFF] to-[#AE00FF] shadow-[0_0_40px_rgba(174,0,255,0.4)] hover:shadow-[0_0_60px_rgba(174,0,255,0.6)] transition-all duration-300" data-id="element-77">
            Book Your Sales OS Audit Call
            <ArrowRight className="w-6 h-6" data-id="element-78" />
          </motion.button>
        </motion.div>
      </div>
    </div>;
};